import { useQuery } from '@tanstack/react-query'
import { listHttpServices } from 'api/admin/httpServices/listHttpServices'
import { httpServicesKeys } from './keys'

export const useHttpServicesQuery = () =>
  useQuery({
    queryKey: httpServicesKeys.list(),
    queryFn: listHttpServices,
    staleTime: Infinity,
  })
